export class Cliente {
  id: string;
  codigo: string;
  nome: string;
  email: string;
  imagem: string;
  identificador: string;
  telefone?: string;
}